(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // controller for agenda appointment historie list  
    module.controller('AgendaAppointmentHistorieListController', [
         'AppointmentService', 
         'HelperService',
         AgendaAppointmentHistorieListControllerFn
    ]);

    function AgendaAppointmentHistorieListControllerFn(
        AppointmentService, 
        HelperService) {
        var vm = this;

        // collapse
        vm.collapsed = false;

        // show all
        vm.all = false;

        activate();

        // collapse
        vm.collapse = function () {
            vm.collapsed = !vm.collapsed;
        };

        // show all
        vm.showAll = function () {
            vm.all = !vm.all;
            load();
        };
       
        // load appointments of patient/user
        function load() {
            // block ui
            HelperService.block("#appointments");
            AppointmentService.getByUser(vm.patientId, vm.all).then(function (result) {
                vm.appointments = result;
                setAppointmentsTodaySeparator(vm.appointments);

                // block ui
                HelperService.unblock("#appointments");
            });
        }

        function setAppointmentsTodaySeparator(appointments) {
            // indicate where past-future (today) separator must be shown
            var prevAppInTheFuture = false;        
            var today = moment();        

            for (var app of appointments) {
                // detect appointment in the past
                if (moment(app.appointmentDate).isAfter(today)) {
                    prevAppInTheFuture = true;
                }

                // detect appointment in the future
                if (moment(app.appointmentDate).isBefore(today) &&
                    prevAppInTheFuture) {
                    app.showTodaySeparator = true;
                    break;
                }
            }
        }

        // activation work
        function activate() {
            // load appointments of patient / user
            load();

            var today = moment(new Date());
            var todayCaption = today.format('dddd') + ', ' + today.format('LL');
            vm.currentDateCaption = todayCaption;
        }
    }
})();